module.exports = __webpack_public_path__ + "img/a01-1.f69f8d7c.png";